<template>
  <form-wrapper :validator="$v.dpfos">
    <div class="row">
      <div class="col-md-12 buttonlist">

        <b-button
          v-b-modal.createDanovnikModal
          class="addRowButton">
          {{ $t('message.butNewDan') }}
        </b-button>

        <b-button
          :pressed.sync="vyhladavanie"
          @click="changeBut"
          class="btn-primary"
          style="margin-left: 5px; background-color: #3a5878;">
          {{ searchLabel }}
        </b-button>

      </div>
      <div class="col-md-7">
        <rest-loading />
        <div v-if="itemCountTo != null && totalRows !== 0">
          <div class="summary">Zobrazujem <b>{{ perPageInfo() }}</b> záznamov.</div>

          <b-form-radio-group
            v-model="id"
            plain
            @input="$route.params.userId = id">
            <table style="width:100%">
              <tr
                v-for="(item, key) in dpfos"
                :key="key"
                class="tr">
                <td
                  class="radio"
                  style="width:50px;"
                  data-col-seq="0">
                  <b-form-radio :value="item.id"/>
                </td>
                <td data-col-seq="1">
                  20{{ item.year }}/{{ item.type }} {{ dodatocne(item.druh) }}
                </td>
                <td data-col-seq="2">
                  {{ item.titul }} {{ item.meno }} {{ item.priezvisko }}
                </td>
                <td data-col-seq="3">
                  {{ dicOrRc(item) }}
                </td>
                <td style="text-align: center">
                  <button
                    v-if="item.year < (new Date().getFullYear() - 2001)"
                    :class="item.druh !== 3 ? 'upCase button btn-primary' : 'upCase button'"
                    @click="copy(item)">
                    Prenos údajov
                  </button>
                </td>
              </tr>
            </table>
          </b-form-radio-group>
          <hr>
          <b-pagination
            :total-rows="totalRows"
            :per-page="10"
            v-model="currentPage"
            size="md"
            @input="switchPage(currentPage,'')"/>

        </div>
        <span v-if="!itemFound">{{ $t('message.msgNotFound') }}</span>
      </div>

      <div class="col-md-5">

        <transition
          name="fade"
          mode="out-in">

          <div
            key="1"
            v-if="!vyhladavanie">
            <bubble-message :message="$t('message.helpNewDan')"/>
            <bubble-message :message="$t('message.helpCopyDan')"/>
          </div>
          <div
            key="2"
            v-else>
            <search-danovnik
              :search-danovnik="searchDanovnik" />

            <b-button
              class="search"
              variant="primary"
              @click="switchPage(currentPage,'')">
              {{ $t('message.butSearch') }}
            </b-button>
          </div>

        </transition>

      </div>

      <create-danovnik />
    </div>
  </form-wrapper>
</template>

<script>
import RestLoading from '@/components/RestLoading.vue';
import bFormGroup from '@/components/form-group-col6';
import restEditor from '@/mixins/restEditor';
import bubbleMessage from '@/components/bubbleMessage.vue';
import CreateDanovnik from './danovnik/CreateDanovnik.vue';
import SearchDanovnik from './danovnik/searchItem.vue';

function dpfosData() {
  return {
    id: null,
    type: null,
    year: null,
    priezvisko: null,
    meno: null,
    dic: null,
    rc: null,
    titul: null,
    druh: null
  };
}

function searchItems() {
  return {
    rok: null,
    typ: null,
    dic: null,
    priezvisko: null
  };
}

export default {
  components: {
    bFormGroup,
    RestLoading,
    CreateDanovnik,
    SearchDanovnik,
    bubbleMessage
  },

  mixins: [restEditor],

  data() {
    return {
      vyhladavanie: false,
      searchLabel: this.$t('message.butSearch'),
      currentPage: 1,
      totalRows: 0,
      itemCountTo: null,
      itemCountFrom: null,
      itemFound: true,
      id: null,
      dpfos: [dpfosData()],
      searchDanovnik: [searchItems()],
    };
  },

  validations: {
    dpfos: {
      type: {},
      year: {},
      priezvisko: {},
      meno: {},
      dic: {},
      rc: {},
      titul: {},
      druh: {},
    },
    searchDanovnik: {
      rok: {},
      typ: {},
      dic: {},
      priezvisko: {},
    },
  },

  methods: {
    dicOrRc(item) {
      if (item.dic) {
        return item.dic;
      }
      return item.rc;
    },
    dodatocne(value) {
      if (value === 3) {
        return 'Dod.';
      }
      return null;
    },

    perPageInfo() {
      return `${this.itemCountFrom} - ${this.itemCountTo}  z ${this.totalRows}`;
    },

    loadItems(data) {
      this.totalRows = data._meta.totalCount;
      this.currentPage = data._meta.currentPage;

      if (data.items.length) {
        this.dpfos = [];
        this.itemCountTo = null;
        this.itemFound = true;
      } else {
        this.itemFound = false;
      }

      data.items.forEach((item) => {
        const newItem = dpfosData(null);

        newItem.id = item.id;
        newItem.type = item.type.toUpperCase();
        newItem.druh = item.druh;
        newItem.year = item.year;
        newItem.priezvisko = item.priezvisko;
        newItem.meno = item.meno;
        newItem.dic = item.dic;
        newItem.rc = item.rc;
        newItem.titul = item.titul;

        this.dpfos.push(newItem);
        this.itemCountTo += 1;
      });
      this.itemCountFrom = 1 + ((this.currentPage - 1) * 10);
      this.itemCountTo = this.itemCountTo + ((this.currentPage - 1) * 10);
    },

    async processGet() {
      this.loadItems(await this.restDataSource.listFo(1, ''));
    },

    search() {
      let adress = '';
      if (this.searchDanovnik.rok) {
        adress = `${adress}&filter[year]=${this.searchDanovnik.rok}`;
      }
      if (this.searchDanovnik.typ) {
        adress = `${adress}&filter[type]=${this.searchDanovnik.typ}`;
      }
      if (this.searchDanovnik.dic) {
        adress = `${adress}&filter[dic][like]=${this.searchDanovnik.dic}`;
      }
      if (this.searchDanovnik.priezvisko) {
        adress = `${adress}&filter[priezvisko][like]=${this.searchDanovnik.priezvisko}`;
      }
      return adress;
    },

    async switchPage(currPage, search) {
      let adress = search;
      if (this.vyhladavanie) {
        adress = this.search();
      }
      this.loadItems(await this.restDataSource.listFo(currPage, adress));
      this.id = null;
    },
    async changeBut() {
      if (this.vyhladavanie) {
        this.searchLabel = this.$t('message.butBack');
      } else {
        this.loadItems(await this.restDataSource.listFo(1, ''));
        this.searchLabel = this.$t('message.butSearch');
      }
    },
    async copy(value) {
      if (value.druh === 3) {
        alert('Prenos údajov nie je možné pre dodatočné danové priznanie');
        return null;
      }
      const responseId = await this.restDataSource.copyFo(value.id);
      this.$router.push({ name: 'danovnik', params: { userId: responseId } });
      return null;
    },
  },

};
</script>

<style>
.triangle-right.right {
    margin-right: 40px;
    background: #3a5878;
}
.triangle-right {
    position: relative;
    padding: 15px;
    margin: 0 0 3em;
    color: #fff;
    background: #3a5878;
}
.triangle-right.right::after {
    top: 15px;
    right: -30px;
    bottom: auto;
    left: auto;
    border-width: 0px 0px 35px 45px;
    border-color: transparent #3a5878;
}
.triangle-right::after {
    content: "";
    position: absolute;
    bottom: -20px;
    left: 50px;
    border-width: 20px 0 0 20px;
    border-style: solid;
    border-color: #075698 transparent;
    display: block;
    width: 0;
}
.triangle-right {
    color: #fff;
}
.triangle-right a {
    color: #29cab9;
}
.triangle-right .media {
    font-size: 95%;
}
.shadow6:before, .shadow6:after{
  position:absolute;
  content:"";
  top:80px;bottom:15px;left:50px;right:50px;
  z-index:-1;
  box-shadow:0 0 50px 2px #486685;
  border-radius:100px/20px;
}
.media-left {
    padding-right: 14px;
}
.tr {
  background-color: #e2ecfa;
  border-bottom: 4px solid #fafaff;
}
.radio {
  text-align: center;
}
table, th, td {
    padding: 5px;
    margin-top: 5px;
}
td {
  text-align: left;
  margin-top: 5px;
}
.buttonlist {
  margin-top: 20px;
  margin-bottom: 5px;
}
.search {
  margin-left: 295px;
}
.button {
  opacity: 0;
}
tr:hover .button {
  opacity: 1;
}

ul.pagination li.page-item > a {
  color: #3a5878;
}
ul.pagination li.page-item.active > a {
  color: #fff;
}

.page-item.active .page-link {
  background-color: #3a5878;
  border-color: #3a5878;
}
</style>
